export const DIVISION_RANGES = {
  "Beginner": "2.0–3.0",
  "Low Intermediate": "3.1–3.49",
  "Intermediate": "3.5–3.9",
  "High Intermediate": "4.0–4.49",
  "Advanced": "4.5–4.99",
  "Contender": "5.0–5.49",
  "Future Pro": "5.5–5.99",
  "Pro": "6.0–7.59",
  "G.O.A.T.": "7.6–8.0",
};

export const DIVISION_PSI_WINDOWS = {
  "Beginner": "0–40",
  "Low Intermediate": "40.1–62.2",
  "Intermediate": "62.3–84.4",
  "High Intermediate": "84.5–106.7",
  "Advanced": "106.8–128.0",
  "Contender": "128.1–150.3",
  "Future Pro": "150.4–172.6",
  "Pro": "172.7–194.8",
  "G.O.A.T.": "194.9–198",
};

export const DIVISION_ORDER = { "Beginner": 0, "Low Intermediate": 1, "Intermediate": 2, "High Intermediate": 3, "Advanced": 4, "Contender": 5, "Future Pro": 6, "Pro": 7, "G.O.A.T.": 8 };

export const ALL_DIVISIONS = Object.keys(DIVISION_RANGES);

export const divisionRange = (label) => {
  const key = ALL_DIVISIONS.find((k) => (label || "").startsWith(k));
  return key ? DIVISION_RANGES[key] : null;
};
